import { isSameDay, startOfDay } from "date-fns";
import { DataSourceCalculation } from "../../api/models/DataSource";

type EmissionsFactorGroup = {
    year: number;
    calculations: DataSourceCalculation[];
};

export const groupEmissionsFactorCalculationsByYear = (
    calculations: DataSourceCalculation[]
): EmissionsFactorGroup[] => {
    const uniqueYears = Array.from(
        new Set(
            calculations.map((calculation) =>
                new Date(calculation.activeFrom).getFullYear()
            )
        )
    );

    return uniqueYears.map((year) => ({
        year,
        calculations: calculations.filter(
            (calculation) =>
                new Date(calculation.activeFrom).getFullYear() === year
        ),
    }));
};

export const getMostRecentCalculationsPerDate = (
    calculations: DataSourceCalculation[]
): DataSourceCalculation[] => {
    const mostRecentCalculationList: DataSourceCalculation[] = [];
    const uniqueDates = Array.from(
        new Set(
            calculations.map((calculation) =>
                startOfDay(new Date(calculation.activeFrom)).getTime()
            )
        )
    );

    uniqueDates.forEach((uniqueDate) => {
        const calculationsByDate = calculations.filter((calculation) =>
            isSameDay(new Date(calculation.activeFrom), uniqueDate)
        );
        const mostRecentCalculationByDate = calculationsByDate.reduce(
            (prev, current) => {
                const prevDate = new Date(prev.createdAt).getTime();
                const currentDate = new Date(current.createdAt).getTime();
                return prevDate > currentDate ? prev : current;
            }
        );

        mostRecentCalculationList.push(mostRecentCalculationByDate);
    });

    return mostRecentCalculationList;
};
